import React from 'react';
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Customized,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Text,
} from 'recharts';
import DefaultLoader from '~/components/DefaultLoader';
import { useFluxoDeCaixa } from '../../hook/useFluxoDeCaixa';
import { LegendChart, ContainerChart, LegendChartContent } from './styles';
import { formatCurrencyAsText } from '~/utils/functions';

export const Grafico: React.FC = () => {
  const { loading, chartInfos } = useFluxoDeCaixa();

  const contaKeys =
    chartInfos.length > 0
      ? Object.keys(chartInfos[0])
          .filter((key) => !Number.isNaN(Number(key)))
          .sort((a, b) => Number(a) - Number(b))
      : [];

  const colors = [
    '#FF6361',
    '#0088FE',
    '#e96523',
    '#00C49F',
    '#A28BFE',
    '#ffd900',
  ];

  return (
    <ContainerChart>
      {loading && <DefaultLoader />}
      {!loading && (
        <>
          <ResponsiveContainer width="88%" height={400}>
            <ComposedChart
              data={chartInfos}
              margin={{
                top: 20,
                right: 20,
                bottom: 20,
                left: 45,
              }}
            >
              <CartesianGrid stroke="#282828" />
              <XAxis dataKey="dta_diario" />
              <YAxis
                tickFormatter={(value: number) => formatCurrencyAsText(value)}
              />
              <Area
                type="monotone"
                dataKey="CONSOLIDADO"
                name="CONSOLIDADO"
                fill="#e8b195"
                stroke="#feb08a"
                strokeWidth={2}
                dot={false}
              />
              {contaKeys.map((key, index) => (
                <Line
                  key={key}
                  dataKey={key}
                  name={chartInfos[0].descricoes[key]}
                  stroke={colors[index % colors.length]}
                  strokeWidth={2}
                  dot={false}
                />
              ))}
              <Customized
                component={() => {
                  return chartInfos.length === 0 ? (
                    <Text
                      style={{ transform: `translate(50%, 50%)` }}
                      x={0}
                      y={-20}
                      textAnchor="middle"
                      verticalAnchor="middle"
                    >
                      Nenhum registro encontrado.
                    </Text>
                  ) : null;
                }}
              />
              <Tooltip
                formatter={(value: number) => formatCurrencyAsText(value)}
              />
              <Legend />
            </ComposedChart>
          </ResponsiveContainer>
          <LegendChart>
            <LegendChartContent>
              <span style={{ color: '#feb08a' }}>-- Consolidado</span>
              {contaKeys.map((key, index) => {
                return (
                  <span style={{ color: `${colors[index % colors.length]}` }}>
                    -- {chartInfos[0].descricoes[key]}
                  </span>
                );
              })}
            </LegendChartContent>
          </LegendChart>
        </>
      )}
    </ContainerChart>
  );
};
